import {Component, Input} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {EnvService} from "../services/env.service";
import {BaseComponent} from "../base/base.component";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";
import {LookupService} from "../srvs/lookup";

@Component({
  selector: 'micro-contactGroup-detail',
  templateUrl: './contactGroup-detail.component.html'
})
export class ContactGroupDetailComponent extends BaseComponent {
  @Input() contactGroup: any;

  isCompanyAdmin: boolean = false;
  contacts: any[] = [];

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router: Router,
              private lookupService: LookupService,
              private alertService: AlertService,
              public auth: AuthService) {
    super(env, http);
  }

  protected onInit(): void {
    this.isCompanyAdmin = this.auth.isCompanyAdmin();
    if (this.contactGroup) {
      this.loadContacts();
      return;
    }

    this.route.params.subscribe((params: Params) => {
      const id: any = params['id'];
      if (id === '0') {
        this.createNew();
      } else {
        this.loadId(id);
      }
    });
  }

  loadId(id: any) {
    this.http.get(`${this.env.e.url}/auth/contactGroups/${id}`, {params: this.companyParams()}).subscribe(
      data => {
        this.setContactGroup(data);
      }
    );
  }

  createNew() {
    this.setContactGroup({
      companyId: (this.isCompanyAdmin && !this.auth.companyIdFilter) ? undefined : this.defaultCompanyId(),
      name: '',
      members: []
    });
  }

  setContactGroup(contactGroup: any) {
    this.contactGroup = contactGroup;
    if (!this.contactGroup.members) {
      this.contactGroup.members = [];
    }
    this.loadContacts();
  }

  onCompanyIdChanged() {
    this.loadContacts();
  }

  loadContacts() {
    if (!this.contactGroup) {
      return;
    }
    this.http.get(`${this.env.e.url}/auth/contacts/all`, {
      params: this.companyParams(this.contactGroup.companyId)
    }).subscribe(
      data => {
        // this.contacts = data as any[];

        let contacts = data as any[];
        for (let contact of contacts) {
          contact.company = this.lookupService.lookup("auth", "contactCompanies", contact.contactCompanyId, "");
          contact.department = this.lookupService.lookup("auth", "contactDepartments", contact.contactDepartmentId, "");
          contact.plDisplayName = `${contact.company} / ${contact.department} / ${contact.name}`;
        }
        this.contacts = contacts;
      }
    );
  }

  save() {
    const params = this.companyParams(this.contactGroup.companyId);
    if (!this.contactGroup.id) {
      this.http.post(`${this.env.e.url}/auth/contactGroups`, this.contactGroup, {params: params}).subscribe(
        data => {
          this.setContactGroup(data);
          this.alertService.info(`Created ${this.contactGroup.name}`);
        }
      );
    } else {
      this.http.put(`${this.env.e.url}/auth/contactGroups/${this.contactGroup.id}`, this.contactGroup, {params: params}).subscribe(
        data => {
          this.setContactGroup(data);
          this.alertService.info(`Updated ${this.contactGroup.name}`);
        }
      );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/auth/contactGroups/${this.contactGroup.id}`, {
      params: this.companyParams(this.contactGroup.companyId)
    }).subscribe(
      complete => {
        this.alertService.info(`Deleted ${this.contactGroup.name}`);
        this.router.navigate(["/contactGroups"]);
      }
    );
  }

  private defaultCompanyId(): string {
    if (this.isCompanyAdmin && this.auth.companyIdFilter && this.auth.companyIdFilter.trim() !== '') {
      return this.auth.companyIdFilter;
    }
    return this.auth.getCompanyId();
  }

  private companyParams(companyId: string = this.defaultCompanyId()): HttpParams {
    return new HttpParams().set("companyId", companyId || '');
  }
}
